import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function CTAButton({
  children,
  href = '#oferta',
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href={href} onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block bg-sageGreen text-white font-bold text-center px-8 py-4 rounded-full shadow-lg hover:bg-sageGreen-dark hover:shadow-xl transition-all duration-300 ${className}`} data-id="element-272">
      {children}
    </motion.a>;
}